import { makeStyles, CSSProperties } from "@mui/styles";
import Theme from "../../themes/theme";

const FONT_SIZE_12 = "12px !important";
const FONT_SIZE_14 = "14px !important";
const FONT_SIZE_16 = "16px !important";
const INLINE_FLEX = "inline-flex";

const boxStyle: CSSProperties = {
  boxSizing: "border-box",
  "&::placeholder": {
    fontSize: FONT_SIZE_16,
    padding: "10px ",
  },
};

export default makeStyles((theme: Theme) => {
  return {
    errorStyle: {
      color: "red",
      fontSize: "10px",
      marginLeft: theme.spacing(1.5),
      marginBottom: theme.spacing(-1),
    },
    insideIconPos: {
      marginTop: -10,
      height: "150%",
      width: "150%",
    },
    dropDownPaper: {
      marginTop: -12,
    },
    hiddenListStyle: {
      minWidth: "50px",
    },
    menuDropDown: {
      maxHeight: "40%",
    },
    searchMenuDropDown: {
      maxHeight: "40%",
      width: `calc(100vw - 2000px)`,
    },
    clearMenuItem: {
      color: theme.dropdown.selected.color,
      fontSize: "14px",
    },
    unselectedMenuItem: {
      color: theme.dropdown.unselected.color,
      fontSize: "14px",
      "&:hover": {
        backgroundColor: theme.dropdown.selected.backgroundColor,
        // color: theme.dropdown.unselected.hover.color,
      },
    },
    selectedMenuItem: {
      color: theme.dropdown.selected.color,
      fontSize: "14px",
      borderLeft: `2px solid ${theme.palette.UI.purple}`,
      backgroundColor: `${theme.dropdown.selected.backgroundColor} !important`,
      "&:hover": {
        color: `${theme.dropdown.selected.color} !important`,
        "& .deleteIcon path": {
          fill: `${theme.palette.UI.grey_500} !important`,
        },
      },
    },

    formControl: {
      width: "100%",
      margin: theme.spacing(1, 1, 1, 0),
    },
    selectInput: {
      padding: 4,
      paddingLeft: 16,
      height: "unset",
      minHeight: 10,
      ...boxStyle,
      "&:focus": {
        backgroundColor: "white",
      },
      fontSize: FONT_SIZE_14,
      color: theme.dropdown.text,
    },
    selectInputOpen: {
      color: theme.palette.UI.purple,
    },
    inputAutofill: {
      "&:-webkit-autofill": {
        WebkitBoxShadow: "0 0 0 1000px white inset",
        WebkitTextFillColor: "black",
      },
    },
    disabledInput: {
      ...boxStyle,
      fontSize: FONT_SIZE_14,
      color: theme.palette.UI.disabled_text,
      border: `1px solid ${theme.palette.UI.disabled}`,
      background: theme.palette.UI.grey_100,
      borderRadius: "4px",
    },
    disabledLabel: {
      color: `${theme.palette.UI.grey_500} !important`,
    },
    disabledDropdown: {
      fontSize: FONT_SIZE_14,
      color: theme.palette.UI.grey_500,
      border: `1px solid ${theme.palette.UI.grey_100}`,
      background: theme.palette.UI.grey_100,
      borderRadius: "4px",
    },
    borderBox: {
      boxSizing: "border-box",
      border: "none",
      borderRadius: "4px",
      maxHeight: "36px",
      color: theme.palette.UI.grey_900,
      fontSize: FONT_SIZE_14,
    },

    inputLabel: {
      fontSize: FONT_SIZE_12,
      color: theme.input.label,
      marginLeft: theme.spacing(2),
      position: "relative",
      display: INLINE_FLEX,
    },
    radioLabel: {
      fontSize: FONT_SIZE_12,
      color: `${theme.input.label} !important`,
    },
    searchableInputLabel: {
      fontSize: FONT_SIZE_12,
      color: theme.input.label,
      marginLeft: theme.spacing(2),
      marginBottom: "5px",
      position: "relative",
      display: INLINE_FLEX,
    },
    inputLabelDropdown: {
      fontSize: "12px",
      color: theme.palette.text.placeholder_text,
      marginLeft: theme.spacing(1.5),
    },
    selectFluid: {
      width: "100%",
      marginTop: "5px",
      flexDirection: "row",
      padding: 0,
      "& input[type=number]": {
        "-moz-appearance": "textfield",
      },
      "& input[type=number]::-webkit-outer-spin-button": {
        "-webkit-appearance": "none",
        margin: 0,
      },
      "& input[type=number]::-webkit-inner-spin-button": {
        "-webkit-appearance": "none",
        margin: 0,
      },
    },
    selectFluidError: {
      width: "100%",
      marginTop: "5px",
      flexDirection: "row",
      padding: "0 45px 0 0",
      "& input[type=number]": {
        "-moz-appearance": "textfield",
      },
      "& input[type=number]::-webkit-outer-spin-button": {
        "-webkit-appearance": "none",
        margin: 0,
      },
      "& input[type=number]::-webkit-inner-spin-button": {
        "-webkit-appearance": "none",
        margin: 0,
      },
    },
    radioMargin: {
      marginTop: "20px !important",
    },
    Datepicker: {
      display: "flex",
      flexDirection: "column",
    },
    DatePickerLabel: {
      color: theme.palette.text.label,
      marginTop: "-7px",
      marginBottom: "6px",
      fontSize: "12px",
      marginLeft: "0px",
    },
    modalList: {
      height: "350px",
      width: "325px",
    },
    listTitle: {
      fontSize: FONT_SIZE_14,
      color: theme.palette.UI.blue_80,
    },
    listSearchIcon: {
      height: "11px !important",
      width: "11px !important",
      margin: "0 4px 0 12px",
    },
    listInputPlaceHolderText: {
      color: "red",
      fontSize: FONT_SIZE_16,
    },
    negativeMargin: {
      marginTop: "-20px",
    },
    listSearch: {
      border: `1px solid ${theme.palette.UI.blue_80}`,
      ...boxStyle,
      borderRadius: "4px",
    },
    listBox: {
      marginTop: "10px",
      border: `1px solid ${theme.palette.UI.blue_80}`,
      ...boxStyle,
      borderRadius: "4px",
      height: "200px",
      overflowY: "scroll",
    },
    listIcon: {
      marginRight: theme.spacing(1),
    },
    modalContent: {
      padding: "20px",
    },
    transferButton: {
      width: "48px",
      height: "40px",
      marginTop: "10px",
      marginRight: "24px",
    },
    listContainer: {
      marginTop: "30px",
    },
    highlight: {
      backgroundColor: theme.palette.background.bright,
    },
    copyToClipboard: {
      cursor: "pointer",
    },
    chips: {
      display: "flex",
      flexWrap: "wrap",
      "& .MuiButtonBase-root": {
        display: INLINE_FLEX,
      },
    },
    chip: {
      marginTop: 0,
      background: "none",
      textTransfrom: "none",
      fontSize: "12px",
      color: theme.chip.text,
      "& .MuiChip-deleteIcon": {
        marginTop: "2px",
      },
    },
    errorIcon: {
      marginRight: "12px",
      position: "absolute",
      right: 0,
    },
    errorSpan: {
      marginTop: 2,
      marginLeft: 5,
      fontSize: 10,
      color: theme.palette.UI.red,
    },
    errorLabel: {
      color: `${theme.palette.UI.red} !important`,
    },
    errorInput: {
      borderColor: `${theme.palette.UI.red}!important`,
    },
    lastChip: {
      color: theme.palette.primary.main,
      fontWeight: 500,
      background: "none",
      "&:hover, &:focus": {
        backgroundColor: theme.palette.UI.white,
        boxShadow: "none",
      },
    },
    crossIconStyle: {
      minWidth: "100px",
    },
    placeholderStyle: {
      fontSize: "14px",
      color: theme.palette.UI.blue_80,
    },
    formControlLabel: {
      fontSize: "14px",
    },
    modalMainHeading: {
      fontSize: FONT_SIZE_16,
      color: theme.palette.UI.black,
    },
    icon: {
      display: "none",
    },
    dropdownIcon: {
      right: "7px",
    },
    hideBorder: {
      "& .MuiOutlinedInput-notchedOutline": {
        border: "none",
      },
    },
    textAreaInput: {
      flexDirection: "row",
      width: "565px",
      height: "36px",
      color: theme.palette.UI.grey_900,
      borderColor: theme.palette.UI.grey_500,
      borderRadius: "4px",
      fontSize: "14px !important",
      padding: "10px 14px",
      marginTop: "7px",
      "&:visited, &:focused, &:active": {
        borderColor: `${theme.palette.UI.secondary_rose} !important`,
      },
      "&:hover": {
        borderColor: `${theme.palette.UI.black} !important`,
      },
    },
    helperText: {
      color: theme.palette.UI.grey_800,
    },
    select: {
      maxHeight: "33px",
      paddingRight: "30px !important",
    },
    manualClassInput: {
      marginBottom: 15,
    },
    noBorder: {
      border: "none",
    },
    searchDropdownInputContainer: {
      fontSize: 14,
      padding: 0,
      lineHeight: 0,
    },
    searchTextBorder: {
      border: `1px solid ${theme.palette.UI.purple}`,
    },
    purpleBackground: {
      backgroundColor: theme.palette.UI.purple,
      color: theme.palette.UI.white,
    },
    purpleText: {
      color: theme.palette.UI.purple,
      cursor: "pointer",
    },
    searchableMenuItem: {
      fontSize: 13,
      borderBottom: `0.5px solid ${theme.palette.UI.grey_100}`,
      "&:hover .deleteIcon": {
        display: "block",
      },
    },
    menuItem: {
      "&:hover": {
        backgroundColor: theme.palette.UI.black_700,
        color: theme.palette.UI.white,
        "& .deleteIcon path": {
          fill: theme.palette.UI.white,
        },
        "& .checkBoxIcon path": {
          stroke: theme.palette.UI.white,
        },
      },
    },
    searchableUl: {
      "& ul": {
        padding: 0,
        minWidth: "38ch",
      },
    },
    BorderedSearchableUl: {
      "& ul": {
        padding: 0,
        minWidth: "25ch",
      },
    },
    noPointerEvent: {
      pointerEvents: "none",
    },
    placeholderText: {
      color: theme.palette.UI.grey_500,
    },
    overflowInitial: {
      overflow: "initial",
    },
    checkbox: {
      paddingTop: 2,
      paddingBottom: 2,
      paddingLeft: 0,
    },
    selectedCheckBox: {
      color: `${theme.palette.UI.black}!important`,
      left: "-2px",
    },
    addIconButton: {
      padding: 4,
    },
    addCustomTimeRangeText: {
      color: theme.palette.UI.purple_700,
      marginLeft: 5,
      marginTop: 2,
      marginBottom: 2,
    },
    deliverAnyTimeText: {
      color: theme.palette.UI.purple_700,
    },
    timeIcon: {
      "& path": {
        fill: `${theme.palette.UI.purple_700}!important`,
      },
    },
    noBlinkingCursor: {
      caretColor: "transparent",
      cursor: "pointer",
    },
    deleteIconButton: {
      right: "8px",
      position: "absolute",
      display: "none",
    },
    dropDownLabel: {
      paddingLeft: 2,
    },
    defaultText: {
      fontWeight: "normal",
      fontSize: "0.75rem",
      paddingRight: 8,
      marginLeft: "auto",
      fontStyle: "italic",
    },
    disableInputLabel: {
      fontSize: FONT_SIZE_12,
      color: `${theme.palette.UI.grey_500} !important`,
      marginLeft: theme.spacing(2),
      position: "relative",
      display: INLINE_FLEX,
    },
    disableIcon: {
      fontSize: "26px !important"
    },
    addMenuItem: {
      color: theme.dropdown.selected.color,
      fontSize: "14px",
      backgroundColor: `${theme.dropdown.unselected.hover.color} !important`,
      "&:hover": {
        color: `${theme.dropdown.selected.color} !important`,
        backgroundColor: `${theme.dropdown.selected.backgroundColor} !important`,
        "& .deleteIcon path": {
          fill: `${theme.palette.UI.grey_500} !important`,
        },
      },
    },
  };
});
